// extracted by mini-css-extract-plugin
export default {"searchIcon":"DropdownIndicator_searchIcon__DVTCd"};